import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceDetail } from "@msuite/utils/types";
import { client } from "@/hono";

export function useIncomingInvoice(incomingInvoiceId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoices", incomingInvoiceId],
		queryFn: async () => {
			const response = await client.incoming_invoices[":incomingInvoiceId"].$get({
				param: { incomingInvoiceId },
			});
			const data = await responseHandler(response);
			return data.incomingInvoice as IncomingInvoiceDetail;
		},
	});

	/** Return */
	return { ...query, incomingInvoice: query.data };
}
